// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__FieldNumber from "../../../../util/FieldNumber.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(onClose) {
  return function (isMoneyIn) {
    return function (id) {
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const dispatchToasts = match$1[1];
      const match$2 = React.useState(function () {
            return Buhta_cabinet__FieldNumber.empty;
          });
      const setSum = match$2[1];
      const sum = match$2[0];
      const match$3 = React.useState(function () {
            return isMoneyIn;
          });
      const setMoneyIn = match$3[1];
      const moneyIn = match$3[0];
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        children: moneyIn ? "Внесение наличных в кассу" : "Снятие наличных из кассы"
                                      }),
                                  JsxRuntime.jsx("button", {
                                        children: JsxRuntime.jsx("img", {
                                              className: "w-6 h-6",
                                              src: StaticAsset.src("/static/icons/close.svg")
                                            }),
                                        onClick: (function (param) {
                                            Curry._1(onClose, undefined);
                                          })
                                      })
                                ],
                                className: "px-6 py-4 flex justify-between"
                              }),
                          JsxRuntime.jsx("hr", {}),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                      className: "justify-center",
                                                      children: "Внести в кассу"
                                                    }),
                                                className: Cn.fromList({
                                                      hd: "py-2 w-full",
                                                      tl: {
                                                        hd: Cn.on("bg-white rounded", moneyIn),
                                                        tl: /* [] */0
                                                      }
                                                    }),
                                                onClick: (function (param) {
                                                    Curry._1(setMoneyIn, (function (param) {
                                                            return true;
                                                          }));
                                                  })
                                              }),
                                          JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                      className: "justify-center",
                                                      children: "Снять из кассы"
                                                    }),
                                                className: Cn.fromList({
                                                      hd: "py-2 w-full",
                                                      tl: {
                                                        hd: Cn.on("bg-white rounded", !moneyIn),
                                                        tl: /* [] */0
                                                      }
                                                    }),
                                                onClick: (function (param) {
                                                    Curry._1(setMoneyIn, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              })
                                        ],
                                        className: "bg-gray-light p-1 rounded-md flex"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Сумма",
                                        type_: "text",
                                        name: "sum",
                                        required: true,
                                        onChange: (function (value) {
                                            Buhta_cabinet__FieldNumber.set(setSum, value);
                                          }),
                                        className: "mt-4",
                                        value: sum.text
                                      })
                                ],
                                className: "px-6 py-4"
                              }),
                          JsxRuntime.jsx("hr", {}),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                      title: "Сохранить",
                                      onClick: (function (param) {
                                          const amount = sum.value;
                                          if (amount === undefined) {
                                            return ;
                                          }
                                          const placement_placement_type = moneyIn ? /* MONEY_PLACEMENT_TYPE_DEPOSIT */1 : /* MONEY_PLACEMENT_TYPE_WITHDRAWAL */2;
                                          const placement_amount = amount.toString(undefined);
                                          const placement = {
                                            placement_type: placement_placement_type,
                                            amount: placement_amount
                                          };
                                          const __x = Buhta_cabinet__Kassa.MoneyPlacementService.create(tenant, id, placement);
                                          $$Promise.get(__x, (function (result) {
                                                  if (result.TAG !== /* Ok */0) {
                                                    return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                                                  }
                                                  Curry._1(onClose, undefined);
                                                  Curry._1(dispatchToasts, {
                                                        TAG: /* Add */0,
                                                        _0: {
                                                          id: Buhta_core__Toast.generateId(undefined),
                                                          text: "Операция выполнена",
                                                          kind: "success",
                                                          onClick: (function (param) {
                                                              
                                                            })
                                                        }
                                                      });
                                                }));
                                        }),
                                      className: "w-full py-3",
                                      disabled: sum.value === undefined,
                                      type_: "submit"
                                    }),
                                className: "px-6 py-4"
                              })
                        ],
                        className: "w-106 bg-white rounded shadow-payroll",
                        onClick: (function (ev) {
                            ev.stopPropagation();
                          })
                      }),
                  className: "absolute inset-0 bg-black/40 flex justify-center items-center",
                  onClick: (function (param) {
                      Curry._1(onClose, undefined);
                    })
                });
    };
  };
}

function KkmMoneyPlacementModal$Desktop(Props) {
  return Curry._1(make(Props.onClose)(Props.isMoneyIn), Props.id);
}

const Desktop = {
  make: KkmMoneyPlacementModal$Desktop
};

function make$1(onClose) {
  return function (isMoneyIn) {
    return function (id) {
      const match = Buhta_core__Tenant.useTenant(undefined);
      const tenant = match[0];
      const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
      const dispatchToasts = match$1[1];
      const match$2 = React.useState(function () {
            return Buhta_cabinet__FieldNumber.empty;
          });
      const setSum = match$2[1];
      const sum = match$2[0];
      const match$3 = React.useState(function () {
            return isMoneyIn;
          });
      const setMoneyIn = match$3[1];
      const moneyIn = match$3[0];
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          className: "bg-black/80 h-100vh w-full"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                          children: moneyIn ? "Внесение наличных в кассу" : "Снятие наличных из кассы"
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: JsxRuntime.jsx("img", {
                                                className: "w-6 h-6",
                                                src: StaticAsset.src("/static/icons/close.svg")
                                              }),
                                          onClick: (function (param) {
                                              Curry._1(onClose, undefined);
                                            })
                                        })
                                  ],
                                  className: "px-6 py-4 flex justify-between"
                                }),
                            JsxRuntime.jsx("hr", {}),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                        className: "justify-center",
                                                        children: "Внести в кассу"
                                                      }),
                                                  className: Cn.fromList({
                                                        hd: "py-2 w-full",
                                                        tl: {
                                                          hd: Cn.on("bg-white rounded", moneyIn),
                                                          tl: /* [] */0
                                                        }
                                                      }),
                                                  onClick: (function (param) {
                                                      Curry._1(setMoneyIn, (function (param) {
                                                              return true;
                                                            }));
                                                    })
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                        className: "justify-center",
                                                        children: "Снять из кассы"
                                                      }),
                                                  className: Cn.fromList({
                                                        hd: "py-2 w-full",
                                                        tl: {
                                                          hd: Cn.on("bg-white rounded", !moneyIn),
                                                          tl: /* [] */0
                                                        }
                                                      }),
                                                  onClick: (function (param) {
                                                      Curry._1(setMoneyIn, (function (param) {
                                                              return false;
                                                            }));
                                                    })
                                                })
                                          ],
                                          className: "bg-gray-light p-1 rounded-md flex"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                          label: "Сумма",
                                          type_: "text",
                                          name: "sum",
                                          required: true,
                                          onChange: (function (value) {
                                              Buhta_cabinet__FieldNumber.set(setSum, value);
                                            }),
                                          className: "mt-4",
                                          value: sum.text
                                        })
                                  ],
                                  className: "px-6 py-4 pb-0"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                        size: "m",
                                        type_: "submit",
                                        className: "w-full mt-4",
                                        onClick: (function (param) {
                                            const amount = sum.value;
                                            if (amount === undefined) {
                                              return ;
                                            }
                                            const placement_placement_type = moneyIn ? /* MONEY_PLACEMENT_TYPE_DEPOSIT */1 : /* MONEY_PLACEMENT_TYPE_WITHDRAWAL */2;
                                            const placement_amount = amount.toString(undefined);
                                            const placement = {
                                              placement_type: placement_placement_type,
                                              amount: placement_amount
                                            };
                                            const __x = Buhta_cabinet__Kassa.MoneyPlacementService.create(tenant, id, placement);
                                            $$Promise.get(__x, (function (result) {
                                                    if (result.TAG !== /* Ok */0) {
                                                      return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы:");
                                                    }
                                                    Curry._1(onClose, undefined);
                                                    Curry._1(dispatchToasts, {
                                                          TAG: /* Add */0,
                                                          _0: {
                                                            id: Buhta_core__Toast.generateId(undefined),
                                                            text: "Операция выполнена",
                                                            kind: "success",
                                                            onClick: (function (param) {
                                                                
                                                              })
                                                          }
                                                        });
                                                  }));
                                          }),
                                        children: "Сохранить"
                                      }),
                                  className: "p-6 pt-0"
                                })
                          ],
                          className: "absolute bg-white  bottom-0 rounded-t-2xl w-full",
                          onClick: (function (ev) {
                              ev.stopPropagation();
                            })
                        })
                  ],
                  className: "fixed inset-0 z-10 ",
                  onClick: (function (param) {
                      Curry._1(onClose, undefined);
                    })
                });
    };
  };
}

function KkmMoneyPlacementModal$Mobile(Props) {
  return Curry._1(make$1(Props.onClose)(Props.isMoneyIn), Props.id);
}

const Mobile = {
  make: KkmMoneyPlacementModal$Mobile
};

export {
  Desktop ,
  Mobile ,
}
/* Buhta_cabinet__Btn Not a pure module */
